import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { SubItem } from "../../data/data";
import { RightOutlined } from "@ant-design/icons";
import useIsMobile from "../mobileVersion/useIsMobile";
interface SubMenuProps extends React.HTMLAttributes<HTMLUListElement> {
  id?: string;
  items: any;
  handleMouseHover?: () => void;
  handleMouseleave?: () => void;
}
const SubMenu = ({
  items,
  handleMouseleave,
  handleMouseHover,
  ...props
}: SubMenuProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const handleItemClick = (item: SubItem) => {
    if (item?.link.includes("http")) {
      window.open(item?.link, "_blank");
    } else {
      navigate(item?.link);
    }
  };
  return (
    <ul {...props} className={`takaful--sub-menu ${props.className ?? ""}`}>
      {items.length > 0 &&
        items.map((item: SubItem, index: number) => (
          <div
            style={{ display: "flex", gap: "0.5rem" }}
            onMouseEnter={handleMouseHover}
            onMouseOut={handleMouseleave}
          >
            {isMobile && <RightOutlined className="takaful--sub-menu-arrow" />}
            <li
              onMouseEnter={handleMouseHover}
              onClick={() => handleItemClick(item)}
              className="takaful--sub-menu-item"
              style={{ width: "100%" }}
              key={index}
            >
              {t(item?.name)}
            </li>
          </div>
        ))}
    </ul>
  );
};

export default SubMenu;
